import { RootDiv, InsuranceText } from '../styles/InsuranceButton.styles';
import { useModalRouter } from '@hooks/useModalRouter';
import { getRoute } from '@utils';

export function InsuranceButton(props: { disabled?: boolean }) {
  const { disabled } = props;
  const modalRouter = useModalRouter();

  const insuranceRedirect = () => {
    if (!disabled) {
      return void modalRouter.push(getRoute('insuranceInfo'));
    }
  };

  return (
    <RootDiv onClick={insuranceRedirect}>
      <InsuranceText>Inscribir seguro complementario</InsuranceText>
    </RootDiv>
  );
}
